export default "__VITE_ASSET__BSiH65c$__"